import { useEffect } from "react";
import Contract from '../table/Tablecontract';
import Modal from "../modal/Modaladdcontract"



const Dashboard = () => {
  useEffect(() => {
    // getPromise(["sales", "purchases"]);
  }, []);


  return (
    <>
    <Modal/>
    <Contract/>
    
     
     </>
  );
};

export default Dashboard;
